import { DefaultStyle } from '../../constant';
import { Grid, type GridProps } from '@chakra-ui/react';

export type TwoColumnFixedGridProps = GridProps & {
	columnTemplate?: string;
};

const TwoColumnFixedGrid = ({
	children,
	columnTemplate = '60% 40%',
	...rest
}: TwoColumnFixedGridProps) => {
	return (
		<Grid
			alignItems={'start'}
			gap={DefaultStyle.GRID_GAP}
			templateColumns={{
				base: '1fr',
				md:   columnTemplate,
			}}
			{...rest}
		>
			{children}
		</Grid>
	);
};

export default TwoColumnFixedGrid;